import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import SimpleRoutes from './SimpleRoutes';
import PublicReportRoutes from './PublicReportRoutes';

// project imports
import Loadable from 'ui-component/Loadable';

// Teleradnow corporate landing — served at /
// Berry demo landing remains at /pages/landing via AuthenticationRoutes
const TeleradnowLanding = Loadable(lazy(() => import('views/landing')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [{ path: '/', element: <TeleradnowLanding /> }, AuthenticationRoutes, LoginRoutes, SimpleRoutes, PublicReportRoutes, MainRoutes],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
